import React from 'react'

export default function Logo({ className = 'h-8 w-auto' }: { className?: string }) {
  return (
    <div className="flex items-center gap-2">
      <svg className={className} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        {/* Spoke lines */}
        <line x1="32" y1="32" x2="32"  y2="8"  stroke="#D8CEBD" strokeWidth="3.5" strokeLinecap="round"/>
        <line x1="32" y1="32" x2="52"  y2="44" stroke="#D8CEBD" strokeWidth="3.5" strokeLinecap="round"/>
        <line x1="32" y1="32" x2="12"  y2="44" stroke="#D8CEBD" strokeWidth="3.5" strokeLinecap="round"/>
        {/* Spoke nodes — currentColor adapts to light/dark context */}
        <circle cx="32" cy="8"  r="5.5" fill="currentColor" opacity="0.75"/>
        <circle cx="52" cy="44" r="5.5" fill="currentColor" opacity="0.75"/>
        <circle cx="12" cy="44" r="5.5" fill="currentColor" opacity="0.75"/>
        {/* Center hub */}
        <circle cx="32" cy="32" r="8.5" fill="#B85C38"/>
      </svg>
      <span className="text-2xl sm:text-3xl font-semibold tracking-wide">
        <span className="font-italiana">Flux</span>
        <span className="font-sfpro">Labs</span>
      </span>
    </div>
  )
}
